const data = 
[
    {
        "brand": "Sony",
        "camera": "A6100",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "3.20",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "4.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "3.01",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅳ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅳ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A7R IVA",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "4.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": 3.1,
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "6.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "3.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A7C",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.0",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Please set the [Ctrl w/ Smartphone] to be off.\n(Network) → [Ctrl w/ Smartphone] → [Off]\n3.Set \"USB Connecting\" to be \"PC Remote\":\n (Network) → [PC Remote Function] →[PC Remote]→[On]\n4.Set \"Still Img. Save Dest.\" to be \"Camera Only\":\n (Network) → [PC Remote Function] →[Still Img. Save Dest.]→[Camera Only]\n5.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.01",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the SCORP Pro before the camera.\n2.Support Optical Zoom when equiped with a Motorize Lens; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please set the [Ctrl w/ Smartphone] to be off.\n (Network) → [Ctrl w/ Smartphone] → [Off]"
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.01",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the gimbal before the camera.\n2.Support Optical Zoom when equiped with a Motorize Lens; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please set the [Ctrl w/ Smartphone] to be off：\n(Network) → [Ctrl w/ Smartphone] → [Off]"
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.01",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1.Please set the [Ctrl w/ Smartphone] to be off：\n(Network) → [Ctrl w/ Smartphone] → [Off]\n2.Set \"USB Connecting\" to be \"PC Remote\":\n (Network) → [PC Remote Function] →[PC Remote]→[On]\n3.Set \"\"Still Img. Save Dest.\"\" to be \"\"Camera Only\"\":\n (Network) → [PC Remote Function] →[Still Img. Save Dest.]→[Camera Only]\n4.The camera icon on the gimbal screen lights up after a successful connection. And the screen of the camera displays the characters \"PC\".\n5.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama.\n6.after swaping from one cable to another, both camera and gimbal need to be rebooted."
    },
    {
        "brand": "Sony",
        "camera": "FX3",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1.Please set the [Ctrl w/ Smartphone] to be off：\n(Network) → [Ctrl w/ Smartphone] → [Off]\n2.After connecting the cable, be sure to power on the gimbal  before the camera.\n3.The camera icon on the gimbal screen lights up after a successful connection.\n4.Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n5.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama.\n6.after swaping from one cable to another, both camera and gimbal need to be rebooted."
    },
    {
        "brand": "Sony",
        "camera": "FX3",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1.Please set the [Ctrl w/ Smartphone] to be off：\n(Network) → [Ctrl w/ Smartphone] → [Off]\n2.Set \"USB Connecting\" to be \"PC Remote\":\n (Network) → [PC Remote Function] →[PC Remote]→[On]\n3.Set \"\"Still Img. Save Dest.\"\" to be \"\"Camera Only\"\":\n (Network) → [PC Remote Function] →[Still Img. Save Dest.]→[Camera Only]\n4.The camera icon on the gimbal screen lights up after a successful connection. And the screen of the camera displays the characters \"PC\".\n5.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama.\n6.After swaping from one cable to another, both camera and gimbal need to be rebooted."
    },
    {
        "brand": "Sony",
        "camera": "A7 IV",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1.After connecting the cable, be sure to power on the gimbal before the camera.\n2.Operate digital zoom,the camera's digital zoom function needs to be turned on."
    },
    {
        "brand": "Sony",
        "camera": "A7 IV",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V104",
        "note": "1.Please set the [Ctrl w/ Smartphone] to be off：\n(Network) → [Ctrl w/ Smartphone] → [Off]\n2.Set \"USB Connecting\" to be \"PC Remote\":\n (Network) → [PC Remote Function] →[PC Remote]→[On]Set the \"USB Connection\" to be \"Computer Remote\". The specific setting method is as follows: Step 1: Set the computer remote control on the camera.MENU -- network -- transmission/remote -- Computer remote control function -- computer remote control -- open\n3.When using the electronic focusing function of the camera, you need to set the lens mode to AF and camera mode to MF.\n4.Settings to avoid losing photos when taking photos: \n Network → Transfer/Remote → PC Remote Control → Still Img. Save Dest. → Camera only."
    },
    {
        "brand": "Sony",
        "camera": "DSC-RX10 IV",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V104",
        "note": "1.After connecting the cable, be sure to power on the gimbal before the camera.\n2.Operate digital zoom,the camera's digital zoom function needs to be turned on.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "FDR-AX60",
        "controlLine": "Type-C to Multi",
        "photo": "×",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V104",
        "note": "1.After connecting the cable, be sure to power on the gimbal before the camera.\n2.Operate digital zoom,the camera's digital zoom function needs to be turned on.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Sony",
        "camera": "FDR-AX700",
        "controlLine": "Type-C to Multi",
        "photo": "×",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V104",
        "note": "1.After connecting the cable, be sure to power on the gimbal before the camera.\n2.Operate digital zoom,the camera's digital zoom function needs to be turned on.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;"
    },
    {
        "brand": "Canon",
        "camera": "Powershot G7 X Mark Ⅲ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.1",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.Be sure camera Wi-Fi is off before connecting the cable\n2.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur.\n3.Switch to \"MF\" Mode on the lens when use pull focus.\n4.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off"
    },
    {
        "brand": "Canon",
        "camera": "EOS M50",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.1.0",
        "gimbalFirmware": "Gimbal_V104",
        "note": "1.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur.\n2.Switch to \"MF\" Mode on the lens when use pull focus.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off"
    },
    {
        "brand": "Canon",
        "camera": "EOS M50 Mark Ⅱ",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.1",
        "gimbalFirmware": "Gimbal_V121",
        "note": "1.switch to \"MF\" Mode on the lens when use pull focus."
    },
    {
        "brand": "Canon",
        "camera": "EOS 200D Ⅱ",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur.\n2.When using the gimbal to control focus electronically, you may need to switch the lens between AF and MF to see which best fits your need.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off.\n4. camera needs to be powered on in photo mode, otherwise the camera screen may not display."
    },
    {
        "brand": "Canon",
        "camera": "EOS 850D",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur.\n2.When using the gimbal to control focus electronically, you may need to switch the lens between AF and MF to see which best fits your need.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off."
    },
    {
        "brand": "Canon",
        "camera": "EOS 80D",
        "controlLine": "Type-C to Mini",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.2",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur.\n2.When using the gimbal to control focus electronically, you may need to switch the lens between AF and MF to see which best fits your need.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off."
    },
    {
        "brand": "Canon",
        "camera": "EOS 90D",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "Gimbal_V104",
        "note": "1.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur.\n2.When using the gimbal to control focus electronically, you may need to switch the lens between AF and MF to see which best fits your need.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off.\n4. camera needs to be powered on in photo mode, otherwise the camera screen may not display."
    },
    {
        "brand": "Canon",
        "camera": "EOS 6D",
        "controlLine": "Type-C to Mini",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.1.8",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur.\n2.When using the gimbal to control focus electronically, you may need to switch the lens between AF and MF to see which best fits your need.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off."
    },
    {
        "brand": "Canon",
        "camera": "EOS 6D Mark Ⅱ",
        "controlLine": "Type-C to Mini",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.1.1",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur.\n2.When using the gimbal to control focus electronically, you may need to switch the lens between AF and MF to see which best fits your need.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off."
    },
    {
        "brand": "Canon",
        "camera": "EOS 5D Mark Ⅲ",
        "controlLine": "Type-C to Mini",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.3.5",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur.\n2.When using the gimbal to control focus electronically, you may need to switch the lens between AF and MF to see which best fits your need.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off."
    },
    {
        "brand": "Canon",
        "camera": "EOS 5D Mark Ⅳ",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.1.2",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur.\n2.When using the gimbal to control focus electronically, you may need to switch the lens between AF and MF to see which best fits your need.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off."
    },
    {
        "brand": "Canon",
        "camera": "EOS 5DS R",
        "controlLine": "Type-c to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.1.1",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur.\n2.When using the gimbal to control focus electronically, you may need to switch the lens between AF and MF to see which best fits your need.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off."
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.6.0",
        "gimbalFirmware": "Gimbal_V121",
        "note": "1.Please switch photo / video mode on camera manually. \n2.Switch to \"MF\" Mode on the lens when use pull focus.\n3.Please do not use the release cable to control the video recording while in photo mode in RP camera as it is easy to cause the camera crash.\n4.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off\n5.It shows that using the adapter with the EF Mount Lens will increase the delay of pull focus.\n6.If connect camera to external device via HDMI Cable, need to set the \"HDMI Display\" to be display both on camera screen and on the other device to control capture photo or video recording."
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.Please switch photo / video mode on camera manually. \n2.Switch to \"MF\" Mode on the lens when use pull focus.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off\n4.It shows that using the adapter with the EF Mount Lens will increase the delay of pull focus.\n5.If connect camera to external device via HDMI Cable, need to set the \"HDMI Display\" to be display both on camera screen and on the other device to control capture photo or video recording."
    },
    {
        "brand": "Canon",
        "camera": "EOS R5",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.9.0",
        "gimbalFirmware": "Gimbal_V121",
        "note": "1.Please switch photo / video mode on camera manually. \n2.Switch to \"MF\" Mode on the lens when use pull focus.\n3.Please do not use the release cable to control the video recording while in photo mode in R5 camera as it is easy to cause the camera crash.\n4.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off\n5.It shows that using the adapter with the EF Mount Lens will increase the delay of pull focus.\n6.If connect camera to external device via HDMI Cable, need to set the \"HDMI Display\" to be display both on camera screen and on the other device to control capture photo or video recording."
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.4.0",
        "gimbalFirmware": "Gimbal_V104",
        "note": "1.Please switch photo / video mode on camera manually. \n2.Switch to \"MF\" Mode on the lens when use pull focus.\n3.Please do not use the release cable to control the video recording while in photo mode in R6 camera as it is easy to cause the camera crash.\n4.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off\n5.It shows that using the adapter with the EF Mount Lens will increase the delay of pull focus.\n6.If connect camera to external device via HDMI Cable, need to set the \"HDMI Display\" to be display both on camera screen and on the other device to control capture photo or video recording."
    },
    {
        "brand": "Canon",
        "camera": "EOS-1D X Mark Ⅲ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.1.0",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.Set the camera to video mode before power on，otherwise control failure may occur.\n2.The camera and gimbal need to be power on before connecting the data cable"
    },
    {
        "brand": "Canon",
        "camera": "EOS R3",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.1.1",
        "gimbalFirmware": "Gimbal_V1.04",
        "note": "1.Switch to \"MF\" Mode on the lens when use pull focus,set the camera to MF mode (adjusting speed is slow)\n2.Can control the photos and videos in photo mode, only video in video mode"
    },
    {
        "brand": "Canon",
        "camera": "EOS R5C",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0.1",
        "gimbalFirmware": "Gimbal_V1.04",
        "note": "1.After the gimbal and camera are turned on, you need to wait about 10 seconds to establish a connection\n2.When the camera is in photo file, the gimbal can control taking and recording;\n3.When the camera is in video file, the gimbal can control recording\n4.When you look back at an image, you have to switch to photo, and when you look back at a video, you have to switch to video"
    },
    {
        "brand": "Canon",
        "camera": "EOS M6 Mark Ⅱ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "Gimbal_V1.04",
        "note": "1.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur.\n2.Switch to \"MF\" Mode on the lens when use pull focus.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off\n4.Be sure camera Wi-Fi is off before connecting the cable"
    },
    {
        "brand": "Canon",
        "camera": "EOS R7",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.1",
        "gimbalFirmware": "Gimbal_V1.04",
        "note": "1.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur.\n2.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off."
    },
    {
        "brand": "Canon",
        "camera": "EOS R10",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.1",
        "gimbalFirmware": "Gimbal_V1.04",
        "note": "1.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur.\n2.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off."
    },
    {
        "brand": "Canon",
        "camera": "EOS R8",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "Gimbal_V1.04",
        "note": "Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS R50",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "Gimbal_V1.04",
        "note": "1.Please switch photo / video mode on camera manually.\n2.Switch to \"MF\" Mode on the lens when use pull focus."
    },
    {
        "brand": "Canon",
        "camera": "EOS R6 Mark Ⅱ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.1.2",
        "gimbalFirmware": "Gimbal_V1.04",
        "note": "1.Please switch photo / video mode on camera manually.\n2.Switch to \"MF\" Mode on the lens when use pull focus."
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": 1.2,
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.Set the USB Mode to be PC(tether) on camera.\n2.Turn off the Camera Wi-Fi before use the cable to control camera as Wi-Fi and USB Trigger can not used at the same time.\n3.The camera will auto focus when control capture photo.\n4.To pull focus with gimbal, the focus mode toggle on the camera should be set to MF.\n5.When the camera is connected to the gimbal, if you open the album and do nothing, the camera may freeze."
    },
    {
        "brand": "Panasonic",
        "camera": "GH5",
        "controlLine": "Type-C to DC2.5mm",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 2.6,
        "gimbalFirmware": "Gimbal_V103",
        "note": "When switched to Photo mode, the camera won't respond to video-capturing commands; when switched to video mode, the camera won't respond to photo-capturing commands."
    },
    {
        "brand": "Panasonic",
        "camera": "GH5",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": 2.6,
        "gimbalFirmware": "Gimbal_V103",
        "note": "1.Set the USB Mode to be PC(tether) on camera.\n2.Turn off the Camera Wi-Fi before use the cable to control camera as Wi-Fi and USB Trigger can not used at the same time.\n3.The camera will auto focus when control capture photo.\n4.To pull focus with gimbal, the focus mode toggle on the camera should be set to MF.\n5.When the camera is connected to the gimbal, if you open the album and do nothing, the camera may freeze."
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "controlLine": "Type-C to DC2.5mm",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 2.7,
        "gimbalFirmware": "Gimbal_V101",
        "note": "Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "controlLine": "Type-C to DC2.5mm",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 2,
        "gimbalFirmware": "Gimbal_V101",
        "note": "Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Panasonic",
        "camera": "S5",
        "controlLine": "Type-C to DC2.5mm",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 2,
        "gimbalFirmware": "Gimbal_V101",
        "note": "Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Panasonic",
        "camera": "S5",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": 2,
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.Set the USB Mode to be PC(tether) on camera.\n2.Turn off the Camera Wi-Fi before use the cable to control camera as Wi-Fi and USB Trigger can not used at the same time.\n3.The camera will auto focus when control capture photo.\n4.To pull focus with gimbal, the focus mode toggle on the camera should be set to MF."
    },
    {
        "brand": "Panasonic",
        "camera": "S1H",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 2.4,
        "gimbalFirmware": "Gimbal_V102",
        "note": "1.Set the USB Mode to be PC(tether) on camera.\n2.Turn off the Camera Wi-Fi before use the cable to control camera as Wi-Fi and USB Trigger can not used at the same time.\n3.The camera will auto focus when control capture photo.\n4.To pull focus with gimbal, the focus mode toggle on the camera should be set to MF."
    },
    {
        "brand": "Panasonic",
        "camera": "GH6",
        "controlLine": "Type-C to DC2.5mm",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 1.2,
        "gimbalFirmware": "Gimbal_V104",
        "note": "Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Panasonic",
        "camera": "GH6",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": 1.2,
        "gimbalFirmware": "Gimbal_V104",
        "note": "1.Set the USB Mode to be PC(tether) on camera.\n2.Turn off the Camera Wi-Fi before use the cable to control camera as Wi-Fi and USB Trigger can not used at the same time.\n3.The camera will auto focus when control capture photo.\n4.To pull focus with gimbal, the focus mode toggle on the camera should be set to MF."
    },
    {
        "brand": "Panasonic",
        "camera": "S5 Ⅱ",
        "controlLine": "Type-C to DC2.5mm",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 1,
        "gimbalFirmware": "Gimbal_V104",
        "note": "Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Panasonic",
        "camera": "S5 Ⅱ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": 1,
        "gimbalFirmware": "Gimbal_V104",
        "note": "1.Set the USB Mode to be PC(tether) on camera.\n2.Turn off the Camera Wi-Fi before use the cable to control camera as Wi-Fi and USB Trigger can not used at the same time.\n3.The camera will auto focus when control capture photo.\n4.To pull focus with gimbal, the focus mode toggle on the camera should be set to MF."
    },
    {
        "brand": "Nikon",
        "camera": "Z7",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "×",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the \nFeiyu SCORP PRO before the camera and wait for about 6 seconds for successfully connection after camera power on\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Nikon",
        "camera": "Z7 Ⅱ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the \nFeiyu SCORP PRO before the camera and wait for about 6 seconds for successfully connection after camera power on\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Nikon",
        "camera": "Z5",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.11",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the \nFeiyu SCORP PRO before the camera and wait for about 6 seconds for successfully connection after camera power on\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Nikon",
        "camera": "Z6",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the \nFeiyu SCORP PRO before the camera and wait for about 6 seconds for successfully connection after camera power on\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Nikon",
        "camera": "Z6 Ⅱ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the \nFeiyu SCORP PRO before the camera and wait for about 6 seconds for successfully connection after camera power on\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Nikon",
        "camera": "Z50",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.After connecting the cable, be sure to power on the \nFeiyu SCORP PRO before the camera and wait for about 6 seconds for successfully connection after camera power on\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Nikon",
        "camera": "Zfc",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.10",
        "gimbalFirmware": "Gimbal_V103",
        "note": "1.After connecting the cable, be sure to power on the Feiyu gimbal before the camera and wait for about 6 seconds for successfully connection after camera power on\n2.Please switch photo / video mode on camera manually.\n3.To operate digital focusing in video mode, you need to set the camera's focusing mode to AF-FS or AF-FC.  When operating digital focus in photo mode, the focus mode of the camera cannot be MF mode."
    },
    {
        "brand": "Nikon",
        "camera": "Z9",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.10",
        "gimbalFirmware": "Gimbal_V104",
        "note": "1.After connecting the cable, be sure to power on the Feiyu gimbal before the camera and wait for about 6 seconds for successfully connection after camera power on\n2.Please switch photo / video mode on camera manually.\n3.To operate digital focusing in video mode, you need to set the camera's focusing mode to AF-FS or AF-FC.  When operating digital focus in photo mode, the focus mode of the camera cannot be MF mode."
    },
    {
        "brand": "Nikon",
        "camera": "Z30",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V104",
        "note": "1.After connecting the cable, be sure to power on the Feiyu gimbal before the camera and wait for about 6 seconds for successfully connection after camera power on\n2.Please switch photo / video mode on camera manually.\n3.To operate digital focusing in video mode, you need to set the camera's focusing mode to AF-FS or AF-FC.  When operating digital focus in photo mode, the focus mode of the camera cannot be MF mode."
    },
    {
        "brand": "Nikon",
        "camera": "D7500",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "×",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.10",
        "gimbalFirmware": "Gimbal_V121",
        "note": "1.After connecting the cable, be sure to power on the Feiyu gimbal before the camera and wait for about 6 seconds to hear the \"click\" sound for successfully connection after camera power on\n2.Control the camera with the gimbal, the camera Live View function needs to be enabled\n3.Gimbal can control camera recording only when the camera is turned on in video recording mode\n4.The camera screen does not show the duration of the video, but only lights\n5.The camera button is unavailable when connected to the gimbal\n6.When controlling the electronic focus, the lens needs to be in AF mode and is slow"
    },
    {
        "brand": "Nikon",
        "camera": "D850",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.2",
        "gimbalFirmware": "Gimbal_V121",
        "note": "1.After connecting the cable, be sure to power on the gimbal before the camera and wait for about 6 seconds to hear the \"click\" sound for successfully connection after camera power on\n2.Control the camera with the gimbal, the camera Live View function needs to be enabled\n3.Gimbal can control camera recording only when the camera is turned on in video recording mode\n4.If you go back to the album and play the video, you have to reconnect to control it again."
    },
    {
        "brand": "Nikon",
        "camera": "Z8",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.01",
        "gimbalFirmware": "Gimbal_V121",
        "note": "1.After connecting the cable, be sure to power on the gimbal before the camera and wait for about 6 seconds to hear the \"click\" sound for successfully connection after camera power on\n2.Control the camera with the gimbal, the camera Live View function needs to be enabled\n3.Gimbal can control camera recording only when the camera is turned on in video recording mode\n4.If you go back to the album and play the video, you have to reconnect to control it again."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.01",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.After switch to video mode on camera manually, Feiyu SCORP PRO can control camera to start recording."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.After switch to video mode on camera manually, Feiyu SCORP PRO can control camera to start recording."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A5",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "×",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A7",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "×",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V103",
        "note": "Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "×",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.01",
        "gimbalFirmware": "Gimbal_V101",
        "note": "Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "3.01",
        "gimbalFirmware": "Gimbal_V101",
        "note": "Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S10",
        "controlLine": "Type-C to TRS3.5\n(Optional)",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.02",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo/ video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "controlLine": "Type-C to TRS3.5\n(Optional)",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo/ video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-E3",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.22",
        "gimbalFirmware": "Gimbal_V101",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo/ video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30 Ⅱ",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "Gimbal_V104",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.After switch to video mode on camera manually, The Feiyu SCORP can control camera to start recording."
    },
    {
        "brand": "Fujifilm",
        "camera": "X100V",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "Gimbal_V104",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo/ video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "GFX 100S",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 1.32,
        "gimbalFirmware": "Gimbal_V104",
        "note": "Please switch photo/ video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H2S",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 1,
        "gimbalFirmware": "Gimbal_V104",
        "note": "Please switch photo/ video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H2",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 1.21,
        "gimbalFirmware": "Gimbal_V120",
        "note": "Please switch photo/ video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T5",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 1.02,
        "gimbalFirmware": "Gimbal_V104",
        "note": "Please switch photo/ video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S20",
        "controlLine": "Type-C to TRS3.5\n(未标配)",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 1.11,
        "gimbalFirmware": "Gimbal_V121",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.After switch to video mode on camera manually, The Feiyu SCORP can control camera to start recording."
    },
    {
        "brand": "SIGMA",
        "camera": "FP",
        "controlLine": "Type-C to Type-C",
        "photo": "×",
        "video": "√",
        "lineTimeMonitor": "×",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "4.00",
        "gimbalFirmware": "Gimbal_V104",
        "note": "1.The camera icon on the gimbal screen lights up after a successful connection.\n2.When the cable is connected, the camera button function cannot be used.\n3.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur."
    },
    {
        "brand": "BMPCC",
        "camera": "BMPCC 6K",
        "controlLine": "Type-C to Type-C",
        "photo": "×",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "V7.3",
        "gimbalFirmware": "Gimbal_V102",
        "note": "1.The camera icon on the gimbal screen lights up after a successful connection.\n2.When the cable is connected, the camera button function cannot be used.\n3.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur."
    },
    {
        "brand": "BMPCC",
        "camera": "BMPCC 4k",
        "controlLine": "Type-C to Type-C",
        "photo": "×",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "V7.3",
        "gimbalFirmware": "Gimbal_V104",
        "note": "1.The camera icon on the gimbal screen lights up after a successful connection.\n2.When the cable is connected, the camera button function cannot be used.\n3.When taking photos or recording video from the gimbal, it is recommended to manually set the camera to the corresponding mode, otherwise control failure may occur."
    }
]
export default data